import type { MediaRoom } from './liveMedia.service';

import { AGORA } from '@/constants';
import store from '@/store';

let usingCloudProxy = false;

export function setUsingCloudProxy(value: boolean) {
  usingCloudProxy = value;
}

export const getTrackingValues = (mediaRoom: MediaRoom) => {
  if (!mediaRoom) {
    return {};
  }
  const isScreen = mediaRoom.channelName?.includes(AGORA.UID_SUFFIX.SCREEN_STREAM);
  return {
    page: store.state.route.name,
    eventId: store.state.route.params?.eventID,
    channelName: mediaRoom.channelName,
    isScreen: isScreen,
    userRole: mediaRoom.userRole,
    isUsingCloudProxy: usingCloudProxy,
    proxyMode:
      store.state.mediaroom.channelPeerConnectionStates?.[mediaRoom.channelName]?.progressiveCloudProxyMode ||
      store.state.mediaroom.channelPeerConnectionStates?.[mediaRoom.channelName]?.turnServerUrl ||
      'no',
    lr: window.logrocketSessionUrl,
    organizationId: store.state.event.organization?.id,
    orgnaizationName: store.state.event.organization?.name,
    useCloudProxyFlow: store.state.event.useCloudProxyFlow,
    turnServerFallbackStatus:
      store.state.mediaroom?.channelPeerConnectionStates[mediaRoom.channelName]?.turnServerFallbackStatus,
    turnServerUrl: store.state.mediaroom.channelPeerConnectionStates[mediaRoom.channelName]?.turnServerUrl,
    isUserHost: store.getters['event/isBroadcastSpeakerOrOrganizer']
  };
};
